import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { backButton } from '@telegram-apps/sdk-react';

import { InputContent } from '@/components/common/InputContent/InputContent.tsx';
import { infoBlockWrapper } from '@/components/UserProfile/styles.ts';
import { useDialogsStore } from '@/store/useDialogsStore.ts';
import { routes } from '@/navigation/routes.tsx';
import { useUnmatchAction } from '@/hooks/useUnmatchAction.tsx';
import { unmatchAction } from '@/components/Popup/UserProfile/styles.ts';

type ReportBlockProps = {
  hid: string;
  name: string;
};

export const UnmatchBlock = ({ hid, name }: ReportBlockProps) => {
  const { t } = useTranslation();

  const { removeDialog } = useDialogsStore();
  const navigate = useNavigate();

  const handleUnmatch = async () => {
    await removeDialog({ hid: hid, shouldCallApi: true });

    backButton.hide();
    navigate(routes.messenger);
  };

  const openUnmatchPopup = useUnmatchAction(hid, name, handleUnmatch);

  const handleOpenUnmatchPopup = () => {
    void openUnmatchPopup();
  };

  return (
    <InputContent style={{ marginTop: 10, marginBottom: 10 }}>
      <div style={infoBlockWrapper} onClick={handleOpenUnmatchPopup}>
        <div style={unmatchAction}>{t('unmatch_action')}</div>
      </div>
    </InputContent>
  );
};
